import { BASEURL } from '../../Constants';

async function postLoginRequest(path, body) {
  try {
    const response = await fetch(`${BASEURL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    return await response.json();
  } catch (error) {
    return {
      error: 1,
      message: 'Unable to reach the authentication service. Please try again.',
    };
  }
}

export function SendLogin(email, password) {
  return postLoginRequest('/user/login', { email, password });
}

export function VerifyLoginMfa(challengeToken, code) {
  return postLoginRequest('/user/login/mfa/verify', {
    challenge_token: challengeToken,
    code,
  });
}

export function ResendLoginMfa(challengeToken) {
  return postLoginRequest('/user/login/mfa/resend', {
    challenge_token: challengeToken,
  });
}
